import AuthService from "../../service";
const groupVisit = {
  getGroupVisit(page,search,sort_date,sort_branch) {
    return AuthService.get(`service/group_visit?`+
      `page=${page}` +
      `&sort_date=${sort_date}` +
      `&sort_branch=${sort_branch}` +
      `&search=${search}`
    );
  },
  showGroupVisit(id) {
    return AuthService.get("/service/group_visit/" + id);
  },
  createGroupVisit(data) {
    return AuthService.post("/service/group_visit", data);
  },
  updateGroupVisit(id, data) {
    return AuthService.put("/service/group_visit/" + id, data);
  },
  deleteGroupVisit(id) {
    return AuthService.delete("/service/group_visit/" + id);
  }
};
export default groupVisit;
